import { motion } from "framer-motion";
import { useState } from "react";
import { X } from "lucide-react";

const images = [
  { src: "/assets/coches-ruta.jpeg", alt: "Flota en ruta", span: "md:col-span-2 md:row-span-2" },
  { src: "/assets/coches-terminal.jpeg", alt: "Flota en terminal", span: "md:col-span-1" },
  { src: "/assets/estudiantes.jpeg", alt: "Estudiantes subiendo al bus", span: "md:col-span-1" },
  { src: "/assets/pasajeros.jpeg", alt: "Pasajeros en terminal", span: "md:col-span-1" },
  { src: "/assets/590-monta.jpeg", alt: "Bus en la montana", span: "md:col-span-1" },
];

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.95 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
};

export default function Galeria() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section
      id="galeria"
      className="py-20 md:py-32 bg-[#080f1c]"
      data-testid="galeria-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <span className="text-[#3DD9E8] text-sm font-bold uppercase tracking-[0.3em] font-body">
            Nuestras imagenes
          </span>
          <h2 className="font-heading text-4xl md:text-6xl text-white uppercase tracking-tight mt-3">
            Galeria
          </h2>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-4"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {images.map((img, i) => (
            <motion.div
              key={i}
              className={`relative overflow-hidden group cursor-pointer ${img.span}`}
              variants={itemVariants}
              onClick={() => setLightbox(img)}
              data-testid={`gallery-image-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full min-h-[200px] object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-[#0D1525]/0 group-hover:bg-[#0D1525]/40 transition-colors duration-300 flex items-center justify-center">
                <span className="text-white font-heading text-xl uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Ver
                </span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-[60] bg-black/90 backdrop-blur-sm flex items-center justify-center p-6"
          onClick={() => setLightbox(null)}
          data-testid="lightbox-overlay"
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-[#3DD9E8] transition-colors duration-200"
            onClick={() => setLightbox(null)}
            data-testid="lightbox-close"
          >
            <X size={32} />
          </button>
          <img
            src={lightbox.src}
            alt={lightbox.alt}
            className="max-w-full max-h-[85vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
